/*
创建者 魏强(2018.1.23)
*/
<template>
  <nav class="public-nav-layout">
    <div class="wrapper">
      <!-- <div class="all-category">
        <div class="title" @mouseenter="showCat" @mouseleave="hideCat">
          <h3>
            <router-link to="index">所有商品分类</router-link>
          </h3>
        </div>
        <div class="category" @mouseenter="showCat" @mouseleave="hideCat" style="display: block;" v-show="catShow">
          <ul class="menu clearfix">
            <li v-for="(cat,catindex) in catTree" v-if="cat.children.length" v-bind:class="{ even: catindex%2==1,odd: catindex%2!=1}" :key="cat.catId" :cat_id="catindex+1">
              <div class="class">
                <h4>
                  <router-link :to="{path:'/goods-list',query:{catname:cat.name,cat_id:cat.catId}}" target="_blank">
                    {{cat.name}}
                  </router-link>
                </h4>
                <span v-if="cat" class="recommend-class">
                  <router-link v-for="(cat2,cat2index) in cat.children" v-if="cat2index<3" :to="{path:'/goods-list',query:{catname:cat2.name,cat_id:cat2.catId}}" :key="cat2.catId" target="_blank">
                    {{cat2.name}}
                  </router-link>
                </span>
                <span class="arrow"></span>
              </div>
              <div class="sub-class" :cat_menu_id="catindex+1">
                <dl v-for="cat2 in cat.children" :key="cat2.catId">
                  <dt>
                    <h3>
                      <router-link :to="{path:'/goods-list',query:{catname:cat2.name,cat_id:cat2.catId}}" target="_blank">
                        {{cat2.name}}
                      </router-link>
                    </h3>
                  </dt>
                  <dd class="goods-class" v-if="cat2">
                    <router-link v-for="cat3 in cat2.children" :to="{path:'/goods-list',query:{catname:cat3.name,cat_id:cat3.catId}}" :key="cat3.catId" target="_blank">
                      {{cat3.name}}
                    </router-link>
                  </dd>
                </dl>
              </div>
            </li>
            <li v-if="origin_tree.length > 13" class="show-more" @click="handleShowMore()">
              {{showMore ? "显示更多" : "收起分类"}}
            </li>
          </ul>
        </div>
      </div> -->
      <!--分类树结束-->
      <ul class="site-menu">
        <li>
          <router-link to="index">首页</router-link>
        </li>
        <li>
          <router-link to="enterprise-brand-store" target="_blank">企业网店</router-link>
        </li>
        <li>
          <router-link to="gold-shop">金牌网店</router-link>
        </li>
        <li>
          <router-link to="silver-shop">银牌网店</router-link>
        </li>
        <li>
          <router-link to="personal-shop">个体网店</router-link>
        </li>
        <!-- <li>
          <router-link to="/recommend-goods?type=10" target="_blank">免费换购专区</router-link>
        </li> -->
        <!-- <li>
          <router-link to="/self-owned-mall" target="_blank">直营优品</router-link>
        </li> -->
        <li>
          <router-link to="/recommend-goods?type=8" target="_blank">自营积分专区</router-link>
        </li>
        <li>
          <router-link to="/recommend-goods?type=4" target="_blank">现金劵专区</router-link>
        </li>
        <!-- <li>
          <router-link to="/recommend-goods?type=3" target="_blank">首单免费</router-link>
        </li> -->
        <li>
          <router-link to="/fresh-agricultural" target="_blank">农特生鲜</router-link>
        </li>
        <li>
          <router-link to="/china-time-honored" target="_blank">中华老字号</router-link>
        </li>
        <li>
          <router-link to="/landmark-superior-product" target="_blank">地标优品</router-link>
        </li>
        <li>
          <router-link to="/same-city-businesses">同城商家</router-link>
        </li>
        <!-- <li>
          <router-link to="/login">信息发布</router-link>
        </li> -->
        <!--<li>
          <router-link to="/goods-list?vouchers_status=2" target="_blank">爆款专区</router-link>
        </li>-->
        <!--<li>
          <router-link to="/supply-chain-list">供应链专区</router-link>
        </li>-->
        <!-- <li>
          <router-link to="/paid-information">付费资讯</router-link>
        </li> -->
      </ul>
    </div>
  </nav>
</template>
<script>
import { getCatList } from 'api/home.js'
// 根据路由设置分类菜单是否显示 高春超
export default {
  data() {
    return {
      catTree: [],
      catShow: true, // 根据当前页是否是首页判断商品分类是否显示
      showMore: false,  //是否显示更多分类
      origin_tree: [], //初始的导航数据
    }
  },
  created() {
    this.setCatShow(this.$route.path);
    this.fetchCatList();
  },
  mounted() {
    this.initCatHover()
  },
  watch: {
    '$route'(to, from) {
      this.setCatShow(to.path);
    }
  },
  methods: {
    setCatShow(path) {
      this.catShow = path === '/index' ? true : false;
    },
    showCat() {
      clearTimeout(this.timeout);
      this.catShow = true;
    },
    hideCat() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.setCatShow(this.$route.path);
      }, 200)
    },
    fetchCatList() {
      getCatList({ "categoryId": 0 }).then((json) => {
        if (json.resCode == 1) {
          let catTree = json.data;
          catTree = catTree.filter(cat => cat.children.length);
          this.origin_tree = catTree;
          if (catTree.length > 13) {
            catTree = catTree.slice(0, 12);
            this.showMore = true;
          }
          this.catTree = catTree;
        }
      })
    },
    //处理菜单鼠标移动交互
    initCatHover() {
      $(document).on('mouseover', '.all-category .menu li', function () {
        let $li = $(this);
        $li.addClass('hover');
      });
      $(document).on('mouseout', '.all-category .menu li', function () {
        let $li = $(this);
        $li.removeClass('hover');
      });
    },
    handleShowMore() {
      const { showMore, origin_tree } = this;
      this.showMore = !showMore;
      if (showMore) {
        this.catTree = origin_tree;
      } else {
        this.catTree = origin_tree.slice(0, 12);
      }
    }
  }
}
</script>

<style scoped lang="less">
.show-more {
  text-align: center;
  color: #666;
  line-height: 39px;
  &:hover {
    cursor: pointer;
    color: rgba(255, 0, 0, 0.8);
  }
}
</style>



// WEBPACK FOOTER //
// category-menu-old.vue?b313e8dc